<sn-icon-button
  class="collapseButton"
  icon="keyboard_arrow_left"
  [matTooltip]="'common.collapse' | t"
  [matTooltipPosition]="'after'"
  (click)="setSecondaryNavbarHidden(true)"
  *ngIf="canSeeSecondaryNavbar && !collapsed"
></sn-icon-button>
